// write a message to the MET/TEAM log file
function doLogFileOutput(msg) {
    app.call({
        url: "Log/LogFileOutput",
        params: { message: msg }
    });
}

function urlEncodeSpecialCharacters(value) {
    // This function was written specifically to encode special characters entered on the
    // MET/CAL Prompt screen (CallSheet\DynamicForm) to avoid exceptions when deserializing
    // the JSON passed in the URL.
    // Other uses of this function need to be thoroughly tested, and any alterations to this
    // code require thorouglhy testing the MET/CAL Promtps using any/all of these characters.
    //
    // Complete list of characters to encode:
    //  !   %21     "   %22     #   %23     $   %24     %   %25
    //  &   %26     '   %27     (   %28     )   %29     +   %2B
    //  ,   %2C     /   %2F     :   %3A     ;   %3B     <   %3C
    //  =   %3D     >   %3E     ?   %3F     @   %40     [   %5B
    //  \   %5C     ]   %5D     ^   %5E     `   %60     {   %7B
    //  |   %7C     }   %7D     ~   %7E     sp  %20

    // use a regular expression to replace all instances of each character!
    // string.replace() only replaces the first instance it finds.

    var result = value;
    if (typeof (result) === "string") {

        // MUST replace '%' symbol first, then all other symbols
        result = result.replace(/\%/g, "%25");

        result = result.replace(/ /g, "%20");
        result = result.replace(/!/g, "%21");
        result = result.replace(/"/g, "%5c%22");    // escape the '"' character ('\"')
        result = result.replace(/#/g, "%23");
        result = result.replace(/\$/g, "%24");
        result = result.replace(/\&/g, "%26");
        result = result.replace(/\'/g, "%27");
        result = result.replace(/\(/g, "%28");
        result = result.replace(/\)/g, "%29");
        result = result.replace(/\+/g, "%2b");
        result = result.replace(/\,/g, "%2c");
        result = result.replace(/\//g, "%2f");
        result = result.replace(/\:/g, "%3a");
        result = result.replace(/\;/g, "%3b");
        result = result.replace(/\</g, "%3c");
        result = result.replace(/\=/g, "%3d");
        result = result.replace(/\>/g, "%3e");
        result = result.replace(/\?/g, "%3f");
        result = result.replace(/\@/g, "%40");
        result = result.replace(/\[/g, "%5b");
        result = result.replace(/\\/g, "%5c%5c");   // escape the '\' character ('\\')
        result = result.replace(/\]/g, "%5d");
        result = result.replace(/\^/g, "%5e");
        result = result.replace(/\`/g, "%60");
        result = result.replace(/\{/g, "%7b");
        result = result.replace(/\|/g, "%7c");
        result = result.replace(/\}/g, "%7d");
        result = result.replace(/\~/g, "%7e");
    }

    return result;
}

// Replace only characters that cause saving or viewing issues
function encodeCertainSpecialCharacters(value, replaceApos) {
    var result = value;

    // use a regular expression to replace all instances of each character!
    // string.replace() only replaces the first instance it finds.
    result = result.replace(/#/g, "%23");
    result = result.replace(/\+/g, "%2b");
    result = result.replace(/\&/g, "%26");
    if (replaceApos) {
        result = result.replace(/\'/g, "\'\'");     // apostrophe must be replaced with double escaped apostrophes!
    }
    return result;
}

// edit buttons never enable
// needed for screens where ReadOnly isn't set to a delegate
// TODO: turn into extension on the button class, rather than passing in the button as a parameter
function refreshEditButton(btn, id, text) {
    if (btn == undefined || id == undefined || text == undefined || text == "") { return; };
    btn.enable();
}

// Delegated to it's own function so we can call just this part of it.
function filterController(controller) {
    // work-around
    switch (controller.toLowerCase()) {
        case "callsheets":
            return "WORK_ORDERS";
        case "callsheet":
            return "WORK_ORDERS";
        default:
            return controller.toUpperCase().replace(" ", "_");
    }
}

function getFindTitleFromControllerName(controller) {

    // TODO: create an UCIData item for model (or controller) names, when used as title, like this:
    // [nUCIDataUID], [cModel]    , [cField], [cProperty], [cValue]
    // xxx          , 'CallSheets', 'title' , 'Model'    , 'Work Orders' 

    return ___("FIND_" + filterController(controller) + "_TITLE");
}

function getSelectTitleFromControllerName(controller) {

    var titleString = ___("SELECT_" + filterController(controller) + "_TITLE");

    // if we didnt find anything with SELECT in the language lookup, use the FIND_ equivalent function
    if (titleString == "SELECT_" + filterController(controller) + "_TITLE")
        return getFindTitleFromControllerName(controller);

    return titleString;
}

function getTableName() {

    // Derive the table name.
    var tableName = "";

    // Next check if there is a table definition.
    if (window["myTable"] !== undefined) {
        tableName = window["myTable"];
    }

    if ((tableName) && (tableName.indexOf(" ") > 0 || tableName.toLowerCase() == 'callsheet' || tableName.toLowerCase() == 'alerting')) {
        tableName = "";
    }

    // window["myTable"] may be blank!
    // test again instead of else() branch
    if (!(tableName)) {
        // Otherwise, try to derive it.
        // Derive the URI
        var uri = window.location.toString();
        if (uri.trim().toLowerCase().startsWith("https:"))
            uri = uri.replace("https://", "");
        else
            uri = uri.replace("http://", "");
        uri = uri.substr(uri.indexOf('/') + 1);
        uri = uri.substr(0, uri.indexOf('/'));

        if (uri.toLowerCase() == "pricing") {
            tableName = "Pricing";
        }
        else if (uri.toLowerCase() == "receiving" && window.location.toString().toLowerCase().indexOf('bulk') != -1) {
            // Note: There is no BulkReceiving table in the database - this facilitates setting popup menu states only!
            tableName = "BulkReceivingModel";
        }
        else if (uri.toLowerCase() == "alerting") {
            if (window.location.toString().toLowerCase().indexOf('getparameters') != -1) {
                tableName = "AlertParameters";
            }
            else if (window.location.toString().toLowerCase().indexOf('editschedule') != -1) {
                tableName = "AlertEvents";
            }
        }
        // singularize the uri.
        else if (uri[uri.length - 1] == "y") {
            // Ends in y
            tableName = uri.substr(0, uri.length - 1) + "ies";
        } else {
            // TODO: Need special case for "Addresses" table?
            tableName = uri + "s";
        }
    }

    return tableName;
}



// Launch Manual Templates Editor
// Both parameters are option but you must supply one of them if you want
// something to load...
function LaunchManualTemplate(nCallSheetUIDS, defaultDataCondition, nTypeProcedureDefaultUID, nCallSheetResultUID, callback) {
    var url = "/ManualTemplate/CreateOrResumeCalibration/";
    var query = url + '?';

    // If the user passed in an array of callsheets.
    if (typeof (nCallSheetUIDS) === typeof ([])) {
        // Iterate over them and build the query string.
        for (var i = 0; i < nCallSheetUIDS.length; i++) {
            query += 'nCallSheetUID=' + nCallSheetUIDS[i] + '&';
        }
    } else {
        // Otherwise, just use the value passed in.
        query += 'nCallSheetUID=' + nCallSheetUIDS;
    }

    if (nTypeProcedureDefaultUID === undefined && nCallSheetResultUID === undefined) {
        Ext.Msg.alert(___("Attention"), "Failed to load the manual template.");
        return;
    }

    // Next, populate the information that we know.
    if (nTypeProcedureDefaultUID !== undefined)
        query += '&nTypeProcedureDefaultUID=' + nTypeProcedureDefaultUID;
    if (nCallSheetResultUID !== undefined)
        query += '&nCallSheetResultUID=' + nCallSheetResultUID;

    query += '&defaultDataCondition=' + defaultDataCondition;

    var win = app.openWindow({
        url: query,
        title: ___('Calibrate'),
        resizable: true
    });

    win.on("message", function (tag, obj) {
        if (tag === "recordchanged") {

            var grid = Ext.getCmp('grdWorkOrderResults');
            if (grid !== undefined) {
                var store = grid.getStore();
                if (store !== undefined) {
                    store.reload();
                }
            }

            if (callback !== undefined) {
                try {
                    callback.prototype.constructor.call(this, win);
                } catch (exception) { }
            }
        }
    });
}

function LaunchMETCal(nTypeProcedureDefaultUID, locale, authArgs, nFacilityUID) {

    var isProcDir = $.ajax({
        url: '/TypeProcedureDefault/IsProcDir/',
        type: 'post',
        async: false,
        data: {
            __RequestVerificationToken: getWindowAntiForgeryTokenValue(),
            nTypeProcedureDefaultUID: nTypeProcedureDefaultUID
        },
        dataType: 'json'
    });

    if (JSON.parse(isProcDir.responseText).IsProcDir == true) {
        Ext.Msg.alert(___("ATTENTION_TITLE"), ___("PROC_DIR_NOT_SUPPORTED"));
        return;
    }

    // get the name of the procedure file to run from the Data Sheet field
    $.ajax({
        url: '/CallSheet/GetDataSheetForTpd/',
        type: 'post',
        // ensure PXE is fully written before launching MET/CAL
        async: false,
        data: {
            __RequestVerificationToken: getWindowAntiForgeryTokenValue(),
            nTypeProcedureDefaultUID: nTypeProcedureDefaultUID
        },
        dataType: 'text',
        success: function (result) {
            if (result == null || result === undefined || result.toString() === undefined || result.indexOf(';') < 0) {
                Ext.Msg.alert(___('CALLSHEET_MISSING_PROCEDURE_FILE_TITLE'), ___('CALLSHEET_MISSING_PROCEDURE_FILE_MSG'));
                return;
            }

            var tempResult = result.toString();
            var splitResult = tempResult.split(";");
            var tpdUID = splitResult[0];

            if (tpdUID == '') {
                return;
            }

            var cmdLine = "mcruntime: -puid \"" + tpdUID + "\" -w \"" + recordID + "\"";
            if (locale)
                cmdLine += " -locale \"" + locale + "\"";

            if (nFacilityUID !== null && nFacilityUID !== undefined && nFacilityUID.trim() != '')
                cmdLine += " -fuid \"" + nFacilityUID + "\"";

            cmdLine += authArgs

            // Create an iframe to wrap the request in.
            try {
                var iframe = "<iframe style='display: none;' src='" + cmdLine + "' />";

                // Append it to the window parent (main page). That way, when we close the client window, the request
                // still gets processed.
                $(iframe).appendTo(window.parent.document.body);
            } catch (ex) {
                window.open(cmdLine, "_blank");
            }

            // Close the work order page
            clientWindow.close();
        }
    });
}

// Provide a centralized and easily accessible way to pop up the waiting bar. 
var _msgWaitBar;
function ShowWaitBar() {
    // Just assign the variable to the wait box, this should always pop-up the wait message.
    _msgWaitBar = Ext.MessageBox.wait(___('PLEASE_WAIT') + "...", ___('ATTENTION_TITLE'));
}

function HideWaitBar() {
    if (_msgWaitBar !== undefined) {
        try { _msgWaitBar.hide(); } catch (error) { }
    }
}

function IsNewRecord(uid) {
    if (uid === undefined || uid === null || uid.length == 0) {
        return true;
    }

    return uid.toUpperCase() == '4CA22A04-0079-4033-84A5-E5968C7F3F17';
}

function IsExistingRecord(uid) {
    return !IsNewRecord(uid);
}
